<script setup lang="ts">
import { useThemeStore } from '@/stores/theme'
import { cmsApi } from '@/api/app/cms'

const themeStore = useThemeStore()

// 启动时从后端加载管理员配置的主题，失败时保持 localStorage 缓存值
cmsApi
  .getSiteConfig()
  .then((cfg) => {
    if (cfg.theme) {
      themeStore.setTheme(cfg.theme)
    }
  })
  .catch(() => {})
</script>

<template>
  <RouterView />
</template>
